import React, {Component} from 'react';
import {Button, Col, Form, message, Row, Select} from 'antd';
import {connect} from 'react-redux';

import SearchUser from '@comm/SearchUser';
import {getAccountSearch} from '@store/modules/core_account_search';
import {queryConfigOrgInfo, queryConfigOrgOp} from "@api/core/org";

const {Option} = Select;
const FormItem = Form.Item;

class FormConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      configTitles: {},
      selectedConfig: [],
      configs: [{uuid: this.createRandomId()}],
    };
  }

  componentDidMount() {
    this.getOptions();
    this.getDetail();
    this.props.dispatch(getAccountSearch());
  }

  createRandomId = () =>
    `${(Math.random() * 10000000)
      .toString(16)
      .substr(0, 4)}-${new Date().getTime()}-${Math.random().toString().substr(2, 5)}`;

  getDetail = () => {
    queryConfigOrgInfo({
      orgUuid: this.props.orgUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        if (res.data) {
          this.initValue(res.data);
        }
      } else {
        message.error(res.message);
      }
    });
  };

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const {onSubmit} = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const arr = {};
        this.state.configs.forEach(item => {
          arr[values[`${item.uuid}+key`]] = {
            title: values[`${item.uuid}+title`],
            userUuid: values[`${item.uuid}+userUuid`],
            userName: values[`${item.uuid}+userName`],
          };
        });
        onSubmit(arr);
      }
    });
  };

  initValue = data => {
    let configs = [];
    const selectedConfig = [];
    Object.keys(data).forEach(item => {
      if (data[item]) {
        const uuid = this.createRandomId();
        const params = {};
        params.uuid = uuid;
        params[`${uuid}+key`] = item;
        params[`${uuid}+title`] = data[item].title;
        params[`${uuid}+userName`] = data[item].userName;
        params[`${uuid}+userUuid`] = data[item].userUuid;
        configs.push(params);
        selectedConfig.push(item);
      }
    });
    if (configs.length < 1) {
      configs = [{uuid: this.createRandomId()}];
    }
    this.setState({
      configs,
      selectedConfig,
    });
  };

  getOptions = () => {
    queryConfigOrgOp().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          configTitles: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  add = () => {
    const {configs} = this.state;
    this.setState({
      configs: [...configs, {uuid: this.createRandomId()}],
    });
  };

  sub = uuid => {
    let {configs} = this.state;
    let {selectedConfig} = this.state;
    configs = configs.filter(item => item.uuid !== uuid);
    const params = this.props.form.getFieldsValue();
    const deleteConfig = params[`${uuid}+key`];
    selectedConfig = selectedConfig.filter(item => item !== deleteConfig);
    this.setState({
      configs,
      selectedConfig,
    });
  };

  handleChange = (fieldName, fieldName2) => (value, option) => {
    const params = this.props.form.getFieldsValue();
    const selectedConfig = [];
    Object.keys(params)
      .filter(item => item.indexOf('key') >= 0)
      .forEach(item => {
        if (params[item] && item !== fieldName2) {
          selectedConfig.push(params[item]);
        }
      });
    const titleObj = {};
    titleObj[fieldName] = option.props.children;
    this.props.form.setFieldsValue(titleObj);
    this.setState({
      selectedConfig: [...selectedConfig, value],
    });
  };

  handleUserChange = fieldName => (value, option) => {
    const nameObj = {};
    nameObj[fieldName] = option.props.children;
    this.props.form.setFieldsValue(nameObj);
  };

  render() {
    const {
      form: {getFieldDecorator},
    } = this.props;
    const ItemLayout = {
      labelCol: {span: 5},
      wrapperCol: {span: 15},
    };
    const {configTitles, configs, selectedConfig} = this.state;
    return (
      <Form onSubmit={this.submit}>
        <div style={{marginBottom: 15}}>
          <Button icon="save" style={{marginRight: 10}} htmlType="submit">
            保存
          </Button>
        </div>
        {configs.map((config, index) => {
          getFieldDecorator(`${config.uuid}+title`, {
            initialValue: config[`${config.uuid}+title`],
          });
          getFieldDecorator(`${config.uuid}+userName`, {
            initialValue: config[`${config.uuid}+userName`],
          });
          return (
            <Row key={config.uuid}>
              <Col span={10}>
                <FormItem label="职位" {...ItemLayout}>
                  {getFieldDecorator(`${config.uuid}+key`, {
                    rules: [{required: true, message: '请输入组织名称!'}],
                    initialValue: config[`${config.uuid}+key`],
                  })(
                    <Select
                      onChange={this.handleChange(`${config.uuid}+title`, `${config.uuid}+key`)}
                    >
                      {Object.keys(configTitles).map(item => {
                        return (
                          <Option key={item} disabled={selectedConfig.indexOf(item) >= 0}>
                            {configTitles[item]}
                          </Option>
                        );
                      })}
                    </Select>,
                  )}
                </FormItem>
              </Col>
              <Col span={10}>
                <FormItem label="人员" {...ItemLayout}>
                  {getFieldDecorator(`${config.uuid}+userUuid`, {
                    initialValue: config[`${config.uuid}+userUuid`],
                  })(
                    <SearchUser
                      onChange={this.handleUserChange(`${config.uuid}+userName`)}
                      name={config[`${config.uuid}+userName`]}
                    />,
                  )}
                </FormItem>
              </Col>
              <Col span={4}>
                <FormItem>
                  {index === configs.length - 1 &&
                  configs.length < Object.keys(configTitles).length ? (
                    <Button type="primary" onClick={this.add}>
                      +
                    </Button>
                  ) : null}
                  {configs.length > 1 ? (
                    <Button style={{marginLeft: '8px'}} onClick={() => this.sub(config.uuid)}>
                      -
                    </Button>
                  ) : null}
                </FormItem>
              </Col>
            </Row>
          );
        })}
      </Form>
    );
  }
}

export default connect(state => state)(Form.create({wrappedComponentRef: true})(FormConfig));



// WEBPACK FOOTER //
// ./src/components/hr/org/FormConfig.js